export function buildSatoriMatrix(profile) {
  const step = profile?.progression?.step || 1;
  const stepKey = profile?.progression?.stepInfo?.key || 'discovery';

  return {
    version: 'satori_matrix_v1',
    userStep: step,
    mode: stepKey,

    priority: resolveMatrixPriority(step),

    recommendations: resolveMatrixRecommendations(profile),

    ui: resolveMatrixUI(profile),

    home: resolveHomeMessaging(profile),

    audio: {
      higonoEnabled: false,
      correctionEnabled: Boolean(profile?.correction?.enabled),
      correctionMode: profile?.correction?.mode || 'none',
    },
  };
}

function resolveMatrixPriority(step) {
  if (step >= 5) return 'advanced_insight';
  if (step === 4) return 'stability';
  if (step === 3) return 'confidence';
  if (step === 2) return 'completion';
  return 'discovery';
}

function resolveMatrixRecommendations(profile) {
  const step = profile?.progression?.step || 1;

  if (step === 1) {
    return ['discover_hearen'];
  }

  if (step === 2) {
    return ['complete_profile'];
  }

  if (step === 3) {
    return ['start_regular_listening'];
  }

  if (step === 4) {
    return ['maintain_routine'];
  }

  return ['observe_progress'];
}

function resolveMatrixUI(profile) {
  const step = profile?.progression?.step || 1;

  return {
    showProfileStatus: step >= 2,
    showPersonalizationBadge: step >= 3,
    showRoutineSuggestion: step >= 4,
    showAdvancedInsights: step >= 5,
  };
}

function resolveHomeMessaging(profile) {
  const step = profile?.progression?.step || 1;

  switch (step) {
    case 5:
      return {
        titleFr: 'Votre écoute s’installe dans la durée',
        subtitleFr: 'Hearen vous accompagne avec plus de finesse, sans perturber votre routine.',
        titleEn: 'Your listening is settling in over time',
        subtitleEn: 'Hearen supports you with more subtlety, without disrupting your routine.',
      };

    case 4:
      return {
        titleFr: 'Votre espace d’écoute est prêt',
        subtitleFr: 'Votre profil est actif. Continuez simplement votre routine sonore.',
        titleEn: 'Your listening space is ready',
        subtitleEn: 'Your profile is active. Simply continue your sound routine.',
      };

    case 3:
      return {
        titleFr: 'Votre profil est prêt',
        subtitleFr: 'Hearen peut maintenant adapter l’écoute à votre profil.',
        titleEn: 'Your profile is ready',
        subtitleEn: 'Hearen can now adapt listening to your profile.',
      };

    case 2:
      return {
        titleFr: 'Votre profil commence à prendre forme',
        subtitleFr: 'Complétez votre personnalisation pour affiner l’expérience Hearen.',
        titleEn: 'Your profile is taking shape',
        subtitleEn: 'Complete your personalization to refine your Hearen experience.',
      };

    default:
      return {
        titleFr: 'Découvrir Hearen',
        subtitleFr: 'Commencez doucement, à votre rythme.',
        titleEn: 'Discover Hearen',
        subtitleEn: 'Begin gently, at your own pace.',
      };
  }
}